/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubsdonotrequirearegistrationnumber6Inputs */

const en_clubsdonotrequirearegistrationnumber6 = /** @type {(inputs: Clubsdonotrequirearegistrationnumber6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clubs and associations do not require a business registration number`)
};

const de_clubsdonotrequirearegistrationnumber6 = /** @type {(inputs: Clubsdonotrequirearegistrationnumber6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vereine benötigen keine Firmenbuchnummer`)
};

/**
* | output |
* | --- |
* | "Clubs and associations do not require a business registration number" |
*
* @param {Clubsdonotrequirearegistrationnumber6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const clubsdonotrequirearegistrationnumber6 = /** @type {((inputs?: Clubsdonotrequirearegistrationnumber6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubsdonotrequirearegistrationnumber6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clubsdonotrequirearegistrationnumber6(inputs)
	return de_clubsdonotrequirearegistrationnumber6(inputs)
});
export { clubsdonotrequirearegistrationnumber6 as "clubsDoNotRequireARegistrationNumber" }